<template>
  <div id="return_step4" class="cart_st">
    <div class="box_wrap" data-detail="done_detail">
      <div class="box">
        <div class="box_title">
          <h2 class="done_tit">
            {{ `반품 요청이 완료되었어요!` }}
          </h2>
        </div>

        <ul class="done_images" data-detail="join_done">
          <!-- <li><img src="@/assets/images/svg/return_done.svg" alt="" /></li> -->
          <li class="an_a">
            <div>반품 상품을 수거하러 오시는</div>
            <div>
              택배 기사님을 통해 상품 전달 부탁드립니다.
            </div>
          </li>
        </ul>

        <div class="btn_wrap">
          <router-link :to="{ name: 'store' }" class="box_btn dull">
            <span class="an_t">{{
              $t('views.member.seller.sellerstep3.9960')
            }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.box_wrap {
  .box {
    width: 100%;
    padding: 0 !important;
  }
  width: 100% !important;
  padding: 40px 0px 0px !important;
}
.done_images {
  margin-bottom: 20px !important;
}
.an_a {
  height: 114px;
  div {
    text-align: center;
    font-size: 28px;
    line-height: 38px;
    font-weight: 700;
    color: #2d5fc3;
  }
}
</style>
